import { render, staticRenderFns } from "./CoverageDetailParameter.vue?vue&type=template&id=40d09fd0"
import script from "./CoverageDetailParameter.vue?vue&type=script&lang=ts"
export * from "./CoverageDetailParameter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports